import * as angular from 'angular';
import * as _ from 'underscore';
import { HttpService } from '../../../api/http.service';
import { IApiService } from '../../models/IApiService';
import { BlobService } from '../../services/blob.service';
import { DefinitionsService } from '../../services/definitions.service';
import { NotificationService } from '../../services/notification.service';

class WysiwygInsertImageComponent {
    [x: string]: any;
    public static $inject = ['http', 'blobService', 'notificationService', 'definitionsService'];
    public modalInstance: ng.ui.bootstrap.IModalServiceInstance = this as any;
    public resolve: {
        insertedTokens: string[],
        apiService: IApiService
    };
    public waiting = false;
    public data = {
        file: null,
        url: null as string,
        dataUploadFile: {
            dataUri: null as string,
            imageSize: {
                width: null as number,
                height: null as number
            },
            size: null as number,
            error: null as string,
            cleanup: () => {
                const i = this.data.dataUploadFile;
                i.dataUri = null,
                    i.imageSize = null;
                i.error = null;
            },
            isEmpty: () => {
                const i = this.data.dataUploadFile;
                return _.isEmpty(i.dataUri) ||
                    !i.imageSize.width ||
                    !i.imageSize.height;
            },
            isError: () => {
                return !_.isEmpty(this.data.dataUploadFile.error);
            }
        }
    };
    private showMinImageSize = 250;

    constructor(
        private http: HttpService,
        private blobService: BlobService,
        private notificationService: NotificationService,
        private definitionsService: DefinitionsService

    ) { }

    public uploadeImage = async (dataUri) => {
        if (!dataUri) {
            return null;
        }
        const fd = new FormData();
        fd.append('FileImage', this.blobService.dataUriToBlob(dataUri), '');

        return this.http.post<string>(this.resolve.apiService.wysiwygImage(), fd, {
            transformRequest: angular.identity,
            headers: { 'Content-Type': undefined }
        });
    }

    public uploadedFileImage = () => {
        this.data.dataUploadFile.cleanup();
        if (this.data.file && this.data.file.error) {
            this.data.dataUploadFile.error = this.data.file.error;
        } else {
            this.data.dataUploadFile.dataUri = this.data.file.dataUri;
            this.data.dataUploadFile.imageSize = this.data.file.imageSize;
            this.data.dataUploadFile.size = this.data.file.size;
        }
        this.data.file = null;
        this.data.url = null;
    }

    public save = async () => {
        if (this.data.dataUploadFile.isError() || this.data.dataUploadFile.isEmpty()) {
            return;
        }
        try {
            const imageLink = await this.uploadeImage(this.data.dataUploadFile.dataUri);
            const match = imageLink.match(this.definitionsService.regexGuid);
            const imageToken = _.isEmpty(match) ? null : _.last(match);

            if (_.isEmpty(imageToken)) {
                this.modalInstance.dismiss({ $value: 'cancel' });
            } else {

                const style = this.data.dataUploadFile.imageSize.width >= this.showMinImageSize
                    ? 'style="max-width: 100%;"'
                    : '';

                const embed = `<img src="${imageLink}" ${style} />`;
                this.resolve.insertedTokens.push(imageToken);
                this.modalInstance.close({ $value: embed });
            }
        } catch (error) {
            const msg = error && error.message ? error.message : error;
            this.notificationService.showErrorMessage(msg);
        }
    }

    public cancel() {
        this.modalInstance.dismiss({ $value: 'cancel' });
    }

    public externalUrlChange = async () => {
        try {
            const dataImage = await this.blobService.getDataImageByUrl(this.data.url);
            this.data.dataUploadFile.cleanup();
            this.data.dataUploadFile.dataUri = dataImage.dataUri;
            this.data.dataUploadFile.imageSize = dataImage.imageSize;
            this.data.dataUploadFile.size = dataImage.size;
            this.data.dataUploadFile.error = dataImage.error;
            this.data.file = null;
        } catch (error) {
            this.data.dataUploadFile.cleanup();
            this.data.dataUploadFile.error = error;
        }
    }
}

angular.module('app.common').component('wysiwygInsertImage', {
    template: require('./wysiwygInsertImage.html'),
    controller: WysiwygInsertImageComponent,
    controllerAs: '$ctrl',
    bindings: {
        resolve: '=',
        close: '&',
        dismiss: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/components/wysiwygInsertImage/wysiwygInsertImage.component.ts